export default __webpack_public_path__ + "static/media/suwa_desktop.51f058e4.png";